import { defineStore } from "pinia";

export const useReaderIdStore = defineStore('readerId', {
  state: () => ({
    readerId: null as string | null,
    readerHost: null as string | null,
  }),
  actions: {
    setReaderId(id: string) {
      this.readerId = id;
    },
    setReaderHost(host: string) {
      this.readerHost = host;
    }
  }
});
